'use client';
import { useState, useEffect } from 'react';
import StatCard from '../../StatCard';

type Stat = {
  time: string;
  value: number;
};

type Props = {
  stats: Stat[];
  lastUpdatedTimes: string[];
  setStatValues: React.Dispatch<React.SetStateAction<Stat[]>>;
};

const WithdrawalTickerMobile: FC<Props> = ({
  stats,
  lastUpdatedTimes,
  setStatValues,
}) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setTimeout(() => setHasMounted(true), 50);
  }, []);

  const handleCardClick = (time: string) => {
    const clickedCardIndex = stats.findIndex((stat) => stat.time === time);
    if (clickedCardIndex === -1) {
      return;
    }

    const updatedStats = [...stats];
    const [clickedCard] = updatedStats.splice(clickedCardIndex, 1);
    setStatValues([...updatedStats, clickedCard]);
  };

  return (
    <div className="relative h-[80px] mt-8">
      {stats.map((stat, index) => {
        const { time, value } = stat;
        const offset = index * 10;
        const scale = 1 - index * 0.05;
        const zIndex = stats.length - index;

        return (
          <div
            key={time}
            className={`absolute left-0 right-0 transition-all duration-500 ease-out ${
              hasMounted
                ? 'opacity-100 translate-y-0'
                : 'opacity-0 translate-y-4'
            }`}
            style={{
              top: `${-offset}px`,
              zIndex,
              transform: `scale(${scale})`,
              transformOrigin: 'center',
            }}
          >
            <StatCard
              time={time}
              value={value}
              textSize="text-[24px]"
              onClick={() => handleCardClick(time)}
              animate={lastUpdatedTimes.includes(time)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default WithdrawalTickerMobile;
